"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkAngles = checkAngles;
exports.correctAngles = correctAngles;
function checkAngles(entities) {
  if (!Array.isArray(entities)) {
    entities = [entities];
  }

  // One issue: we could have sa < 0, but also sa + Math.PI * 2 >= 0, which means neither constraint is satisfied. So we
  // have to be careful when creating the arcs.

  entities.forEach(e => {
    let errs = [];
    switch (e.type) {
      case 'ELLIPSE':
      case 'ARC':
        if (!(e.startAngle >= 0)) errs.push(`startAngle >= 0`);
        if (!(e.startAngle < Math.PI * 2)) errs.push(`startAngle < 2 pi`);
        if (!(e.endAngle - e.startAngle >= 0)) errs.push(`endAngle - startAngle >= 0`);
        if (!(e.endAngle - e.startAngle <= Math.PI * 2)) errs.push(`endAngle - startAngle <= 2 pi`);
        if (errs.length > 0) {
          // console.log(e)
          throw new Error(`Angles violate the following constraints: ${errs.join(', ')}`);
        }
        break;
      default:
    }
  });
}
function correctAngles(entities) {
  if (!Array.isArray(entities)) {
    entities = [entities];
  }
  entities.forEach(e => {
    switch (e.type) {
      case 'ELLIPSE':
      case 'ARC':
        while (e.startAngle < 0) {
          e.startAngle += Math.PI * 2;
          e.endAngle += Math.PI * 2;
        }
        while (e.startAngle >= Math.PI * 2) {
          e.startAngle -= Math.PI * 2;
          e.endAngle -= Math.PI * 2;
        }
        while (e.endAngle - e.startAngle <= 0) {
          e.endAngle += Math.PI * 2;
        }
        while (e.endAngle - e.startAngle > Math.PI * 2) {
          e.endAngle -= Math.PI * 2;
        }
        break;
      default:
    }
  });
}